import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-100 to-cream-200 py-10 px-4">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1.5 text-[13px] text-navy-500 hover:text-navy-800 mb-6">
          <ArrowLeft size={15} /> Retour à la connexion
        </Link>

        <div className="bg-white rounded-[22px] shadow-xl p-8 md:p-10">
          <h1 className="font-serif text-2xl text-navy-900 mb-1">Mentions légales</h1>
          <p className="text-navy-300 text-sm mb-8">Site hello-georges.com — application Hello Georges</p>

          <div className="space-y-6 text-[14px] leading-relaxed text-navy-700">
            <section>
              <h2 className="font-semibold text-navy-900 mb-1.5">Éditeur du site</h2>
              <p>
                Le site <strong>hello-georges.com</strong> et l'application <strong>Hello Georges</strong> sont
                édités par <strong>Marion Lumière</strong> (personne physique).<br />
                Adresse : 45 route de Clisson, 44330 Vallet, France<br />
                Contact : contact@hello-georges.com<br />
                Directrice de la publication : Marion Lumière
              </p>
            </section>

            <section>
              <h2 className="font-semibold text-navy-900 mb-1.5">Hébergement</h2>
              <p>
                Le site et les données sont hébergés par&nbsp;:<br />
                <strong>Infomaniak Network SA</strong><br />
                Rue Eugène-Marziano 25, 1227 Les Acacias (Genève), Suisse<br />
                Téléphone : +41 22 820 35 40 — www.infomaniak.com
              </p>
            </section>

            <section>
              <h2 className="font-semibold text-navy-900 mb-1.5">Propriété intellectuelle</h2>
              <p>
                L'ensemble du code, de l'interface, des contenus et de la marque « Hello Georges » est protégé
                par le droit d'auteur. L'œuvre a fait l'objet d'un dépôt daté auprès de l'INPI (e-Soleau).
                Toute reproduction, représentation ou réutilisation, totale ou partielle, sans autorisation
                écrite préalable est interdite.
              </p>
            </section>

            <section>
              <h2 className="font-semibold text-navy-900 mb-1.5">Responsabilité</h2>
              <p>
                Hello Georges est un outil de gestion à accès restreint et sécurisé. L'éditeur met tout en œuvre
                pour assurer la disponibilité et l'exactitude du service, sans pouvoir garantir l'absence
                totale d'interruption ou d'erreur.
              </p>
            </section>

            <section>
              <h2 className="font-semibold text-navy-900 mb-1.5">Données personnelles</h2>
              <p>
                Le traitement des données personnelles est décrit dans notre{' '}
                <Link to="/confidentialite" className="text-gold-600 hover:text-gold-700 underline">
                  Politique de confidentialité
                </Link>.
              </p>
            </section>

            <p className="text-[12px] text-navy-300 pt-4 border-t border-cream-200">
              Dernière mise à jour : 21 juillet 2026.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
